// Step 3: Upload Creative Assets - Alpine.js Component
// Handles creative assets upload and management

import { CampaignUtils } from './shared/campaign_utils_page.js';

document.addEventListener('alpine:init', () => {
  Alpine.data('campaigns_step3_x_data', () => ({
    assets: [], // Array to store creative assets
    assetType: '', // Currently selected asset type
    description: '', // Description for the current asset
    selectedFile: null, // Currently selected file
    tactics: [], // Array to store tactics data from the backend
    
    init() {
      // Initialize component
      
      // Get tactics data from the template ref
      const tacticsTemplate = this.$refs.tacticsData;
      if (tacticsTemplate) {
        this.tactics = JSON.parse(tacticsTemplate.textContent);
      } else {
        this.tactics = [];
        console.warn('Tactics data template not found');
      }
    },
    
    // Check if all tactics are complete
    get allTacticsComplete() {
      return CampaignUtils.allTacticsComplete(this.tactics);
    },
    
    // Toggle asset card visibility
    toggleAssetCard(tacticId) {
      CampaignUtils.toggleAssetCard(tacticId);
    },
    
    // Handle file upload
    handleFileUpload(event) {
      this.selectedFile = CampaignUtils.handleFileUpload(event);
    },
    
    // Add asset to the list
    addAsset() {
      if (!this.assetType || !this.selectedFile || !this.description.trim()) {
        alert('Please fill in all fields and select a file');
        return;
      }
      
      const asset = {
        asset_type: this.assetType,
        file_name: this.selectedFile.name,
        file_size: this.selectedFile.size,
        file_type: this.selectedFile.type,
        description: this.description.trim(),
        file_url: URL.createObjectURL(this.selectedFile) // Create temporary URL for preview
      };
      
      this.assets.push(asset);
      
      // Reset form
      this.assetType = '';
      this.description = '';
      this.selectedFile = null;
      this.$refs.fileInput.value = '';
    },
    
    // Remove asset from the list
    removeAsset(index) {
      this.assets.splice(index, 1);
    },
    

    // Next step functionality
    next_step() {
      if (this.allTacticsComplete) {
        // All tactics are complete, proceed to step 4
        window.location.href = `/shows/${CampaignUtils.getShowId()}/campaigns/${CampaignUtils.getCampaignId()}/step_4`;
      } else {
        // Show error message for incomplete tactics
        alert('Please complete all campaign tactics to proceed to step 4');
      }
    }
  }));
});
